import { resolveMessageSenderDeviceUuid, isOperatorOrSystemSender } from './isOperatorOutboundMessage'

/**
 * Whether an incoming socket message should play sound / raise a browser notification.
 * Device-originated messages (direct or group) notify even when senderUserId matches the
 * logged-in operator (device owner). Platform operator/system sends never notify.
 *
 * @param {object} message
 * @param {string|number|undefined} profileId
 */
export function shouldNotifyIncomingMessage (message, profileId) {
  if (!message || profileId == null || profileId === '') return false
  if (isOperatorOrSystemSender(message)) return false

  const senderDeviceId = resolveMessageSenderDeviceUuid(message)
  if (senderDeviceId) {
    const normalized = senderDeviceId.toLowerCase()
    return normalized !== 'operator' && normalized !== 'system'
  }

  const senderUserId = message.senderUserId ?? message.senderUser?.id
  if (senderUserId == null || senderUserId === '') return false
  return String(senderUserId) !== String(profileId)
}
